import { tylIconCheckBox, tylIconCheckBoxOutlineBlank } from '@tylertech/tyler-icons/standard';
import { ListDropdownFoundation } from './list-dropdown-foundation';
import { ListDropdownAdapter } from './list-dropdown-adapter';
import { TylerIconRegistry } from '../icon';
var ListDropdown = /** @class */ (function () {
    function ListDropdown(_targetElement, config) {
        this._targetElement = _targetElement;
        TylerIconRegistry.define([tylIconCheckBox, tylIconCheckBoxOutlineBlank]);
        this._foundation = new ListDropdownFoundation(new ListDropdownAdapter(this._targetElement), config);
    }
    ListDropdown.prototype.destroy = function () {
        this._foundation.destroy();
    };
    /** Opens the dropdown. */
    ListDropdown.prototype.open = function () {
        this._foundation.open();
    };
    /** Closes the dropdown. */
    ListDropdown.prototype.close = function () {
        this._foundation.close();
    };
    /** Gets the currently highlighted option index in the dropdown. */
    ListDropdown.prototype.getActiveOptionIndex = function () {
        return this._foundation.getActiveOptionIndex();
    };
    /** Toggles the selected option by index. Only applies when in multiselect mode. */
    ListDropdown.prototype.toggleOptionMultiple = function (index, isSelected) {
        return this._foundation.toggleOptionMultiple(index, isSelected);
    };
    /** Activates the first selected option. */
    ListDropdown.prototype.activateSelectedOption = function () {
        this._foundation.activateSelectedOption();
    };
    /** Activates the first non-disabled option. */
    ListDropdown.prototype.activateFirstOption = function () {
        return this._foundation.activateFirstOption();
    };
    /** Activates (highlights) an option by index. */
    ListDropdown.prototype.activateOption = function (index) {
        return this._foundation.activateOption(index);
    };
    /** Activates the first activatable option. */
    ListDropdown.prototype.activateInitialOption = function () {
        return this._foundation.activateInitialOption();
    };
    /** Clears the active option from the dropdown */
    ListDropdown.prototype.clearActiveOption = function () {
        this._foundation.clearActiveOption();
    };
    /** Sets the selected values. Only applies when in multiselect mode. */
    ListDropdown.prototype.setSelectedValues = function (values) {
        return this._foundation.setSelectedValues(values);
    };
    Object.defineProperty(ListDropdown.prototype, "dropdownElement", {
        get: function () {
            return this._foundation.dropdownElement;
        },
        enumerable: true,
        configurable: true
    });
    ListDropdown.prototype.setOptions = function (options) {
        this._foundation.setOptions(options);
    };
    ListDropdown.prototype.appendOptions = function (options) {
        this._foundation.appendOptions(options);
    };
    ListDropdown.prototype.scrollSelectedOptionIntoView = function (animate) {
        this._foundation.scrollSelectedOptionIntoView();
    };
    ListDropdown.prototype.setScrollBottomListener = function (listener, threshold) {
        this._foundation.setScrollBottomListener(listener, threshold);
    };
    ListDropdown.prototype.removeScrollBottomListener = function () {
        this._foundation.removeScrollBottomListener();
    };
    ListDropdown.prototype.setBusyVisibility = function (isVisible) {
        this._foundation.setBusyVisibility(isVisible);
    };
    ListDropdown.prototype.handleKey = function (key) {
        this._foundation.handleKey(key);
    };
    return ListDropdown;
}());
export { ListDropdown };
